import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';

import type {
  AnalysisCategory as AnalysisCategoryType,
  AnalysisPriority as AnalysisPriorityType,
} from '../../types';

import AnalysisCategory from './AnalysisCategory';
import AnalysisPriority from './AnalysisPriority';

export default function AnalysisBadges() {
  const {
    analysis: { analysis },
  } = useEmail();

  return (
    <div className="flex items-center justify-end gap-1">
      <AnalysisPriority priority={analysis?.priority as AnalysisPriorityType} />

      <AnalysisCategory category={analysis?.category as AnalysisCategoryType} />
    </div>
  );
}
